import React from 'react'
import { BrowserRouter as Router, Route } from 'react-router-dom'
import Header from '@components/Page/Header'
import HeaderTopPart from '@components/Page/HeaderTopPart'
import DancesScreen from '@screens/DancesScreen'
import SettingsScreen from '@screens/SettingsScreen'
import LandingPage from '@screens/LandingPage'
import Users from '@screens/Users'
import LoginScreen from '@screens/LoginScreen'
import Signup from '@screens/Signup'
import EditUser from '@screens/EditUser'
import AddEditDanceScreen from '@screens/AddEditDanceScreen'
import AcumSongs from '@screens/AcumSongs'
import AcumVersions from '@screens/AcumVersions'
import ResetPassword from '@screens/ResetPassword'
import ForgotPassword from '@screens/ForgotPassword'
import SignupSuccess from '@screens/SignupSuccess'
import UserProfile from '@screens/UserProfile'
import { useLanguage } from '@state/uses/app'

export default () => {
    const language = useLanguage()
    return (
        <div style={{ direction: language === 'he' ? 'rtl' : 'ltr' }}>
            <HeaderTopPart />
            <Router>
                <Header />
                <Route exact path="/" component={LandingPage}></Route>
                <Route path="/settings" component={SettingsScreen}></Route>
                <Route path="/dances" component={DancesScreen}></Route>
                <Route path="/users" component={Users}></Route>
                <Route path="/login" component={LoginScreen}></Route>
                <Route path="/signup" component={Signup}></Route>
                <Route path="/dance" component={AddEditDanceScreen}></Route>
                <Route path="/edit_user/:id" component={EditUser}></Route>
                <Route path="/acum_search_song" component={AcumSongs}></Route>
                <Route
                    path="/acum_search_version"
                    component={AcumVersions}></Route>
                <Route path="/reset_password" component={ResetPassword}></Route>
                <Route
                    path="/forgot_password"
                    component={ForgotPassword}></Route>
                <Route path="/signup_success" component={SignupSuccess}></Route>
                <Route path="/user_profile" component={UserProfile}></Route>
            </Router>
        </div>
    )
}
